import { useState, useEffect, useMemo } from "react";
import { useApp } from "../model";
import { CONTENT_WIDTH, CONTENT_HEIGHT, ROLES } from "../constants";
export const useRequest = <T>(fetcher: () => Promise<T>, defaultValue?: T) => {
    const [data, setData] = useState(defaultValue);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error>();

    useEffect(() => {
        setLoading(true)
        fetcher()
            .then(res => {
                setData(res)
                setLoading(false)
            })
            .catch(err => {
                setError(err)
                setLoading(false)
            });
    }, [fetcher]);
    return {
        data, loading, error
    };
}

export const useHasAuth = (roleName: string) => {
    const { currentUser } = useApp();
    const roles = currentUser?.roles || [];
    return roles.find(i => i.name === roleName);
}

export const useLayout = (widthRatio: number, heightRatio: number, gapRatio: number, fullScreen: boolean) => {
    const widthBase = fullScreen ? document.documentElement.clientWidth : CONTENT_WIDTH;
    const heightBase = fullScreen ? document.documentElement.clientHeight : CONTENT_HEIGHT;
    const width = useMemo(() => widthRatio * widthBase, [widthRatio, widthBase]);
    const height = useMemo(() => heightRatio * heightBase, [heightRatio, heightBase]);
    const columnGap = useMemo(() => gapRatio * widthBase, [gapRatio, widthBase]);
    const rowGap = useMemo(() => gapRatio * heightBase, [gapRatio, heightBase]);
    return {
        width,
        height,
        columnGap,
        rowGap,
    }
}

export const useAuthInfo = () => {
    const { currentUser } = useApp();
    const roles = currentUser?.roles || [];
    return {
        loadingAuthInfo: !currentUser,
        isElectrician: roles.some(role => role.name === ROLES.ELECTRICIAN),
        isAdmin: roles.some(role => role.name === ROLES.ADMIN),
        isManager: roles.some(role => role.name === ROLES.MANAGER),
        isObserver: roles.some(role => role.name === ROLES.OBSERVER),
        isRegionalHeader: roles.some(role => role.name === ROLES.REGIONAL_HEADER),
    }
}